module.exports = __webpack_public_path__ + "img/early-warning-arm.ff4e4bec.svg";